"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NonPlatformIntegrations = exports.SupportedPlatformIntegrations = void 0;
exports.SupportedPlatformIntegrations = [
    'vsphere',
    'nutanix',
    'external',
];
exports.NonPlatformIntegrations = ['baremetal', 'none'];
//# sourceMappingURL=clusters.js.map